/*!
 * Copyright 2019 Dmitry Chuba
 */
import bsCustomFileInput from './bsCustomFileInput';

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    'use strict';

    $.fn.repeaterFields = function (options) {

        let settings = $.extend({}, options);
        //
        return this.each(function () {
            const field        = $(this);
            const addButton    = '<button type="button" class="add-row btn btn-success btn-sm mt-2">+ Add</button>';
            const removeButton = '<button type="button" class="remove-row position-absolute btn btn-danger btn-sm" style="' +
                'right: -7px;bottom: 10px;height: 24px;line-height: 14px;">x</button>';
            field.find(':input').each(function () {
                const nameAttr = $(this).attr('name');
                $(this).attr('name', `${nameAttr}[]`);
            });
            field.wrapInner('<div class="fields-group repeatable position-relative">');
            const repeatable = field.find('.repeatable').clone().addClass('pr-4');
            repeatable.append(removeButton);
            field.append(addButton);
            field.on('click', '.add-row', function () {
                field.find('.repeatable:last').after(repeatable.clone());
                bsCustomFileInput.init();
            });
            field.on('click', '.remove-row', function () {
                $(this).closest('.repeatable').remove();
            });
        });
    };
}));
